import {getDomain, getHeadersMatchingDomain} from './xhrUtils';

/**
 * Injects the domain-specific headers into ALL requests to the specified domain (matching any subdomain)
 *
 * @param {object} headers {domain: {header_key: value}}}
 */
export function injectXHRHeaders(headers) {
  let defaultOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (...args) {
    let res = defaultOpen.apply(this, args);

    const [, url] = args;
    const requestDomain = getDomain(url);

    if (!requestDomain) return res;

    const headersForDomain = getHeadersMatchingDomain(headers, requestDomain);

    for (let [key, value] of Object.entries(headersForDomain)) {
      if (value) {
        this.setRequestHeader(key, value);
      }
    }

    return res;
  };
}
